<template>
	<div class="land mainland">
		<div class="tips article-content">
			<ol>
				<li>户籍为国外或中国港澳台地区请点击右侧按钮【国外、港澳台】进行注册。</li>
				<li>登录用户名为身份证号，密码为身份证后6位，登录后可修改。</li>
				<li>报名完成（支付完成）后个人信息不能修改，请确保内容齐全、准确无误。</li>
			</ol>
		</div>
		<el-form ref="form" :model="form" :rules="rules" label-width="86px" class="public-big-form">
			<div class="title">个人信息</div>
			<el-form-item prop="name" label="姓名">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item prop="name" label="姓名全拼">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item prop="name" label="性别">
				<el-radio-group v-model="form.resource">
					<el-radio label="男"></el-radio>
					<el-radio label="女"></el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item prop="name" label="护照号">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item prop="name" label="用户名">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item prop="name" label="出生日期">
				<el-date-picker v-model="form.value1" type="date" placeholder="选择日期" :editable="false"></el-date-picker>
			</el-form-item>
			<el-form-item prop="name" label="国家/地区">
				<el-select v-model="form.region" placeholder="请选择活动区域">
					<el-option label="区域一" value="shanghai"></el-option>
					<el-option label="区域二" value="beijing"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="name" label="民族">
				<el-select v-model="form.region" placeholder="请选择活动区域">
					<el-option label="区域一" value="shanghai"></el-option>
					<el-option label="区域二" value="beijing"></el-option>
				</el-select>
			</el-form-item>
			<div class="title">联系方式</div>
			<el-form-item prop="name" label="手机号码">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item prop="name" label="邮箱">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item prop="name" label="现居住地">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item prop="name" label="邮编">
				<el-input v-model="form.name" size="small" placeholder="请输入账号"></el-input>
			</el-form-item>

			<div style="text-align:center">
				<el-button type="primary" @click="submit" class="login-button" :loading="btn_loading">注册</el-button>
			</div>
		</el-form>
	</div>
</template>
<script>
export default {
	data() {
		return {
			btn_loading: false,
			form: {
				name: "",
				pwd: ""
			},
			rules: {
				name: [
					{
						required: true,
						message: "请输入账号",
						trigger: "blur"
					}
				],
				pwd: [
					{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}
				]
			}
		};
	},
	methods: {
		submit() {
			this.$refs["form"].validate(valid => {
				if (valid) {
					this.btn_loading = true;
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.land {
	.tips {
		font-size: 12px;
		margin-bottom: 10px;
		font-weight: bold;
		ol {
			li {
				margin-bottom: 6px;
			}
		}
	}
	.title {
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 10px;
		color: #666;
	}
	padding: 0 10px;
	margin: 30px auto 0;
	::v-deep.el-input__inner {
		height: 36px;
		border: 1px solid #eaeaea;
		font-size: 14px;
		line-height: 36px;
		color: #666;
		border-radius: 0;
	}
	.login-button {
		width: 100%;
		height: 56px;
		border: 1px solid #eaeaea;
		font-size: 18px;
		line-height: 56px;
		padding: 0 10px;
		color: #fff;
	}
}
</style>
